import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './Input.module.scss';
import {emptyFn} from "presentation/common/helpers/utils";

export const Input = (props) => {

  const {
    label = '',
    type = 'text',
    placeholder,
    help,
    className,
    error,
    required,
    onChange,
    onBlur,
    value,
    prefixIcon,
    children,
    disabled = false,
    ...other
  } = props;

  return (
    <div className={clsx(styles.inputContainer, {[styles.inputInvalid]: error}, className)}>
      {label && <label>{required && <span className={styles.required}>*</span>} {label}</label>}
      <div className="mt-1 relative rounded-md">
        {
          children ||
          <input
            disabled={disabled}
            type={type}
            onChange={onChange}
            onBlur={onBlur}
            className={clsx({'pl-10': prefixIcon, [styles.disabled]: disabled})}
            placeholder={placeholder}
            value={value}
            {...other} />
        }

        {
          prefixIcon &&
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {prefixIcon}
          </div>
        }
      </div>
      {help && !error && <p className="mt-2 text-sm text-gray-500">{help}</p>}
      {error && <p className={styles.invalidFeedback}>{error}</p>}
    </div>
  );
};

Input.defaultProps = {
  type: 'text',
  help: '',
  placeholder: '',
  className: '',
  onChange: emptyFn,
  onBlur: emptyFn,
  value: '',
};

Input.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  help: PropTypes.string,
  error: PropTypes.any,
  prefixIcon: PropTypes.node,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.any,
};

export default Input;
